export default __webpack_public_path__ + "static/images/Default.c8123325.png";